import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CustomTooltip } from '../utils/chartUtils';

const HeartRateChart = ({ chartData, timeRangeType }) => {
  const xAxisProps = {
    dataKey: "displayTime",
    angle: 0,
    textAnchor: timeRangeType === 'today' ? "end" : "end",
    height: 80,
    interval: "preserveStartEnd",
    tick: { fontSize: timeRangeType === 'today' ? 12 : 11 }
  };

  return (
    <ResponsiveContainer width="100%" height={350}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis {...xAxisProps} />
        <YAxis label={{ value: 'BPM', angle: -90, position: 'insideLeft' }} />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Line
          type="monotone"
          dataKey="heart_rate"
          stroke="#dc3545"
          strokeWidth={3}
          dot={{ r: timeRangeType === 'today' ? 5 : 3 }}
          activeDot={{ r: 10 }}
          name="Heart Rate"
          connectNulls={true}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default HeartRateChart;